import { Moon, Sun } from "lucide-react";
import { useTheme } from "../utils/ThemeProvider";
import { cn } from "../lib/utils";

/**
 * Light / dark mode toggle. Works on portal, public site, and login.
 */
export function ThemeToggle({ className, variant = "ghost" }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  const base =
    variant === "brand"
      ? "inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white transition hover:bg-white/20 hover:text-[#e0c15a]"
      : variant === "panel"
        ? "inline-flex h-9 w-9 items-center justify-center rounded-full border border-border bg-card text-foreground transition hover:bg-accent"
        : "inline-flex h-9 w-9 items-center justify-center rounded-md text-foreground transition hover:bg-accent";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={cn(base, className)}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Light mode" : "Dark mode"}
    >
      {isDark ? <Sun className="size-4.5 h-[1.15rem] w-[1.15rem]" /> : <Moon className="size-4.5 h-[1.15rem] w-[1.15rem]" />}
    </button>
  );
}
